export interface Version {
  versionNumber: string;
  buildNumber: string;
}

export const version: Version = {
  versionNumber: '1.17.362-corr.g858af81e55',
  buildNumber: '$(OriginalBuildVersion)'
};
